import { Link } from "react-router-dom";
import ar_logo from "../../assets/ar_logo.png";
import { useAuth } from "../../contexts/AuthContext";

const AdminNavBar: React.FC = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error: any) {
      console.error("Failed to logout:", error?.message || error);
      if (error?.response) {
        console.error(
          "Server responded with:",
          error.response.status,
          error.response.data
        );
      }
    }
  };

  return (
    <div className="container-fluid">
      <Link id="logo-container" className="navbar-brand" to="/admin/dashboard/">
        <img id="logo" src={ar_logo} alt="logo" />
      </Link>
      <ul className="navbar-nav me-auto mb-2">
        <li className="text-light ">
          <Link id="home-label" to={`/admin/dashboard/`}>
            Answer Repo
          </Link>
        </li>
      </ul>
      <div className="flex-d">
        <div id="current-user">{user?.email}</div>
        <button className="btn error-page-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminNavBar;
